import React from "react";
import { connect } from "react-redux";
import { Route, Switch, Redirect } from "react-router-dom";
import SideNavigationMenu from "./common/SideNavigationMenu";
import DashboardPage from "./dashboard/DashboardPage";
import AvailableHoursPage from "./availableHours/AvailableHoursPage";
import { Row, Col } from "react-bootstrap";
import AccountHistoryPage from "./accountHistory/AccountHistoryPage";
import UtilizationRequestPage from "./revShareUtilization/UtilizationRequestsPage";
import FaqPage from "./frequentlyAskedQuestions/FaQPage";
import ReportsPage from "../Reports/ReportsPage";
import AdminRevShareDashboard from "./admin/AdminRevShareDashboard";
import ManagerRevShareDashboard from "./manager/ManagerRevShareDashboard";

const RevSharePages = (props) => {
  return (
    <>
      <Col className="rev-share-nav" xl="2" lg="3" md="4">
        <SideNavigationMenu isAdmin={props.profile.isAdmin} isManager={props.profile.isManager} />
      </Col>
      <Col xl="10" lg="9" md="8">
        <Row>
          <Switch>
            <Route exact path="/revshare/">
              <Redirect to="/revshare/dashboard" />
            </Route>
            <Route exact path="/revshare/dashboard" render={() => <DashboardPage profile={props.profile} />} />
            <Route path="/revshare/availablehours" component={AvailableHoursPage} />
            <Route path="/revshare/utilizationrequests" component={UtilizationRequestPage} />
            <Route path="/revshare/accounthistory" component={AccountHistoryPage} />
            <Route path="/revshare/reports" render={(props) => <ReportsPage isManager={true} />} />
            <Route path="/revshare/frequentlyaskedquestions" component={FaqPage} />
            
            {/* Admin dashboard route */}
            <Route 
              path="/revshare/dashboard/admin/:employeeId?" 
              render={() => <AdminRevShareDashboard profile={props.profile} />} 
            />

            {/* Manager dashboard route */}
            <Route 
              path="/revshare/dashboard/manager/:employeeId?" 
              render={() => <ManagerRevShareDashboard profile={props.profile} />} 
            />
          </Switch>
        </Row>
      </Col>
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  return { profile: state.profile };
};

export default connect(mapStateToProps)(RevSharePages);